import { render, staticRenderFns } from "./NavigationSidebarPremium.vue?vue&type=template&id=36e312b8&scoped=true&"
import script from "./NavigationSidebarPremium.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebarPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e312b8",
  null
  
)

export default component.exports